import script from "./CommentRecord.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommentRecord.vue?vue&type=script&setup=true&lang=ts"

import "./CommentRecord.vue?vue&type=style&index=0&id=23a0dc8c&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23a0dc8c"]])

export default __exports__